import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-testimonials").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Autoplay, Pagination],
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
    },
    loop: true,
    speed: 1000,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1700: {
        slidesPerView: 3,
      },
    },
  });
});
